import { Flex, Box, useToken } from "@chakra-ui/react";
import { skinColors } from "src/modules/avatar/baby-customization";
import { BodyText2 } from "src/atoms/typography";

export default function SkinColorSelector({ t, selectedColor, onChange }) {
  const surfaceElevated1 = useToken("colors", "surfaceElevated1");
  const primary = useToken("colors", "primary");

  const colorsEntries = Object.entries(skinColors);
  const colorsList = colorsEntries.map((entry, id) => {
    return (
      <Box
        key={id}
        width="32px"
        height="32px"
        borderRadius="100%"
        boxShadow={
          entry[0] === selectedColor
            ? `0 0 0 2pt ${surfaceElevated1},0 0 0 4pt ${primary}`
            : undefined
        }
        onClick={() => onChange(entry[0])}
        mr="12px"
        bg={entry[1].BaseSkin}
      />
    );
  });

  return (
    <Box>
      <BodyText2 color="highEmphasis">{t("avatar.skinTone")}</BodyText2>
      <Flex pt="8px">{colorsList}</Flex>
    </Box>
  );
}
